/* EPIC CLOTHING — wishlist

   localStorage only, no app, no account required. The store holds product HANDLES and
   nothing else; the wishlist page fetches each product fresh from /products/<handle>.js
   so prices, images and stock are never stale, and a deleted product simply drops out.

   The file is referenced from every product card, so it can be requested many times on
   one page. The guard below means it only ever initialises once. */
(function () {
  if (window.EpicWishlist) return;

  var KEY = 'epic:wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('epic:wishlist:change', { detail: { items: list } }));
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function remove(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) return;
    list.splice(i, 1);
    write(list);
  }

  /* ---------------------------------------------------------------- buttons */

  function paint(btn) {
    var on = has(btn.getAttribute('data-epic-wish'));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.getAttribute(on ? 'data-label-remove' : 'data-label-add');
    if (!label) return;
    btn.setAttribute('aria-label', label);
    var text = btn.querySelector('.epic-wish__t');
    if (text) text.textContent = label;
  }

  function sync() {
    var n = read().length;
    document.querySelectorAll('[data-epic-wish]').forEach(paint);
    document.querySelectorAll('[data-epic-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
  }

  /* The overlay heart needs a positioned ancestor, and the card markup belongs to the
     theme rather than to us. Climb until we hit the element that actually holds the
     product media — that is the card root — and mark it. */
  function hostFor(btn) {
    var el = btn.parentElement;
    for (var i = 0; el && i < 6; i++, el = el.parentElement) {
      if (el.querySelector('img, svg.placeholder-svg, [class*="media"]')) return el;
    }
    return null;
  }

  function placeOverlays(scope) {
    (scope || document).querySelectorAll('.epic-wish--overlay').forEach(function (btn) {
      if (btn.dataset.epicPlaced) return;
      var host = hostFor(btn);
      if (host) {
        host.classList.add('epic-wish-host');
        btn.dataset.epicPlaced = '1';
      }
    });
  }

  /* ---------------------------------------------------------------- money */

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'en-CA', {
        style: 'currency',
        currency: currency || 'CAD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------------------------------------------------------------- page */

  function card(p, opts) {
    var li = document.createElement('li');
    li.className = 'epic-wl__item';

    var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
    var media = img
      ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') + '" alt="" loading="lazy" width="600" height="750">'
      : '<span class="epic-wl__ph"></span>';

    var price = money(p.price, opts.currency, opts.locale);
    var was = p.compare_at_price && p.compare_at_price > p.price
      ? '<s>' + money(p.compare_at_price, opts.currency, opts.locale) + '</s>'
      : '';
    var sold = p.available ? '' : '<span class="epic-wl__sold">Sold out</span>';

    li.innerHTML =
      '<a class="epic-wl__media" href="' + opts.root + 'products/' + p.handle + '">' + media + sold + '</a>' +
      '<div class="epic-wl__body">' +
        '<a class="epic-wl__title" href="' + opts.root + 'products/' + p.handle + '">' + p.title + '</a>' +
        '<p class="epic-wl__price">' + price + ' ' + was + '</p>' +
      '</div>' +
      '<button type="button" class="epic-wl__x" data-epic-wish-remove="' + p.handle + '" aria-label="Remove ' + p.title + ' from wishlist">Remove</button>';

    return li;
  }

  function renderPage(root) {
    var grid = root.querySelector('[data-epic-wish-grid]');
    var empty = root.querySelector('[data-epic-wish-empty]');
    if (!grid) return;

    var handles = read();
    grid.innerHTML = '';

    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    var opts = {
      root: root.getAttribute('data-root') || '/',
      currency: root.getAttribute('data-currency'),
      locale: root.getAttribute('data-locale')
    };

    /* Placeholders first, so the saved order survives the parallel fetches. */
    var slots = handles.map(function () {
      var li = document.createElement('li');
      li.className = 'epic-wl__item is-loading';
      grid.appendChild(li);
      return li;
    });

    handles.forEach(function (handle, i) {
      fetch(opts.root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
        .then(function (p) { slots[i].replaceWith(card(p, opts)); })
        .catch(function () {
          /* Product deleted or unpublished — drop it rather than showing a dead tile. */
          slots[i].remove();
          remove(handle);
          if (!read().length && empty) empty.hidden = false;
        });
    });
  }

  /* ---------------------------------------------------------------- wiring */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-epic-wish]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(btn.getAttribute('data-epic-wish'));
      btn.classList.remove('just');
      if (added) { void btn.offsetWidth; btn.classList.add('just'); }
      return;
    }

    var rm = e.target.closest('[data-epic-wish-remove]');
    if (rm) {
      e.preventDefault();
      remove(rm.getAttribute('data-epic-wish-remove'));
      var page = document.querySelector('[data-epic-wish-page]');
      if (page) renderPage(page);
    }
  });

  /* Another tab changed the list. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    sync();
    var page = document.querySelector('[data-epic-wish-page]');
    if (page) renderPage(page);
  });

  function init() {
    placeOverlays();
    sync();
    var page = document.querySelector('[data-epic-wish-page]');
    if (page) renderPage(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Product grids repaint after filtering or infinite scroll. */
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () { placeOverlays(); sync(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  window.EpicWishlist = {
    read: read, has: has, toggle: toggle, remove: remove, count: function () { return read().length; }
  };
})();
